module.exports = "import React from 'react';\nimport DayPickerInput from 'react-day-picker/DayPickerInput';\nimport 'react-day-picker/lib/style.css';\n\nexport default function MyDatePicker() {\n  return (\n    <DayPickerInput\n      dayPickerProps={{\n        month: new Date(2018, 10),\n        showWeekNumbers: true,\n        todayButton: 'Today',\n      }}\n    />\n  );\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/code-samples/input-02.js
// module id = 798
// module chunks = 168707334958949